import React from 'react';
import { Chip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import VerifiedIcon from '@mui/icons-material/Verified';

const planConfig = {
  basic: { color: '#4caf50', gradient: 'linear-gradient(135deg, #4caf50 0%, #81c784 100%)', icon: StarIcon, label: 'Basic' },
  advance: { color: '#2196f3', gradient: 'linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)', icon: WorkspacePremiumIcon, label: 'Advance' },
  pro: { color: '#9c27b0', gradient: 'linear-gradient(135deg, #9c27b0 0%, #ba68c8 100%)', icon: VerifiedIcon, label: 'Pro' }
};

const normalizePlanKey = (input) => {
  if (!input) return null;
  const s = String(input).toLowerCase();
  if (s.includes('basic')) return 'basic';
  if (s.includes('adv') || s.includes('advance') || s.includes('advanced')) return 'advance';
  if (s.includes('pro') || s.includes('premium') || s.includes('business')) return 'pro';
  if (s.startsWith('plan_')) {
    if (s.includes('basic')) return 'basic';
    if (s.includes('advance')) return 'advance';
    if (s.includes('pro')) return 'pro';
  }
  return null;
};

export default function PlanChip({ plan, size, label }) {
  // Enforce a consistent visual size everywhere. Ignore incoming `size` prop.
  // Accept arrays or objects by stringifying reasonable inputs
  let raw = plan || label || '';
  if (Array.isArray(raw)) raw = String(raw[0] || '');
  if (typeof raw === 'object' && raw !== null) raw = String(raw.plan || raw.code || raw.label || '');

  // Remove common billing-cycle words from any provided label to avoid "Pro (yearly)" text
  const stripCycle = (s) => {
    if (!s) return s;
    return String(s)
      .replace(/\((monthly|yearly|annually)\)/ig, '')
      .replace(/[-–—]\s*(monthly|yearly|annually)/ig, '')
      .replace(/\b(monthly|yearly|annually)\b/ig, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  };

  const key = normalizePlanKey(raw || label);
  const config = planConfig[key];
  if (!config) return null;
  const Icon = config.icon;
  const safeLabel = stripCycle(label || config.label);
  return (
    <Chip
      icon={<Icon sx={{ fontSize: 16, color: 'white !important' }} />}
      label={safeLabel}
      size={"small"}
      sx={{
        background: config.gradient,
        color: 'white',
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 28,
        borderRadius: 8,
        paddingLeft: '8px',
        paddingRight: '8px',
        '& .MuiChip-icon': { color: 'white' }
      }}
    />
  );
}
